module.exports = __webpack_public_path__ + "static/picture_north-054ebf562b13e5b1dde34efbeb89d363.jpg";